import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import moment from "moment";
import { Button, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";

import { ClientNotification } from "@/interfaces/domain/Client";

type NotificationItemProps = {
  notification: ClientNotification;
  onSelect: (notificationId: string) => void;
  onPressDelete: (notificationId: string) => void;
};

const NotificationItem = ({ notification, onPressDelete, onSelect }: NotificationItemProps) => {
  return (
    <Pressable onPress={() => onSelect(notification._id)}>
      <HStack
        flex={1}
        m="2"
        p="2"
        bgColor="white.50"
        shadow="4"
        rounded="md"
        justifyContent="space-between"
        alignItems="center">
        <HStack flex={1}>
          <Button variant="ghost" mr="2" onPress={() => onPressDelete(notification._id)}>
            <Icon as={<MaterialCommunityIcons name="trash-can" />} size="lg" color="red.600" />
          </Button>
          <VStack flex={0.9} space="2">
            <Text fontSize="lg" bold>
              {notification.titulo}
            </Text>
            <Text
              fontSize={{
                base: "sm",
                lg: "md",
              }}>
              {notification.texto}
            </Text>
            <Text fontSize="md" color="primary.600">
              {moment(notification.createdAt).format("DD/MM/YYYY [às] HH:mm")}
            </Text>
          </VStack>
        </HStack>
        <Icon as={<MaterialIcons name="arrow-forward-ios" />} size="lg" color="primary.600" />
      </HStack>
    </Pressable>
  );
};

export default NotificationItem;
